module.exports = __webpack_public_path__ + "static/img/gd-06.238da9e9.jpg";